<template>
  <el-dialog title="打印面单" :visible.sync="dialogVisible" width="500px" :before-close="hide">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-suffix="：">
      <el-row>
        <el-col :span="22">
          <el-form-item label="打印任务数" prop="num">{{ form.printDatas.length }}</el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="打印机" prop="print">
            <BjSelectLov v-model="form.print" :option-list="form.printOptions" :clearable="false" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hide">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="onConfirm">继续打印</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { randomID } from '@/utils';
import webSocket from '@/utils/websocket';
const defaultForm = () => {
  return {
    print: null,
    printDatas: [],
  };
};
export default {
  data() {
    return {
      dialogVisible: false,
      form: defaultForm(),
      rules: {
        print: [{ required: true, message: '请选择打印机', trigger: 'change' }],
      },
    };
  },
  methods: {
    show(info, printDatas) {
      this.form = Object.assign(defaultForm(), info || {});
      // 获取打印数据
      this.form.printDatas = printDatas;
      // 默认打印机
      this.form.print = info.defaultPrinter;
      // 渲染打印机
      this.form.printOptions = info.printers;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    // 打印相关
    onConfirm() {
      const print = {
        task: {
          documents: this.form.printDatas.map(item => {
            return {
              contents: JSON.parse(item.data),
              documentID: item.id,
            };
          }),
          printer: this.form.print, // 打印机名称
          taskID: randomID(),
        },
      };
      webSocket.print(print);
    },
  },
};
</script>
